import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/system/users',
    name: 'POST_USER',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
